import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConstants } from '../../common/common';
import { map, catchError } from 'rxjs/operators';
import { _throw } from 'rxjs/observable/throw';

@Injectable({
  providedIn: 'root'
})
export class EmailtrackingService {

  constructor(public http: HttpClient) { }



  public GetCommunicationTrackingInitialData() {
    return this.http.get(AppConstants.BasePath + 'GetCommunicationTrackingInitialData').pipe(
      map(this.SuccessHandler), catchError(this.ErrorHandler)
    );
  }


  public GetCommunicationTrackingSearch() {
    return this.http.get(AppConstants.BasePath + 'GetCommunicationTrackingSearch').pipe(
      map(this.SuccessHandler), catchError(this.ErrorHandler)
    );
  }

  public SearchEmail(data: any) {
    return this.http.post(AppConstants.BasePath + 'SearchCommunicationTracking', data).pipe(
      map(this.SuccessHandler), catchError(this.ErrorHandler)
    );
  }


  private SuccessHandler(response: Response) {
    let data = response;
    return data || {};
  }

  private ErrorHandler(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const err = error || '';
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    return _throw(error);
  }


}
